import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { initMeasurement } from '@/lib/measurement';
import '@/styles/index.css';

// Consent, attribution and page views must be armed before the first render,
// so the landing page view and the stored campaign touch are never missed.
initMeasurement();

const container = document.getElementById('root');
if (container === null) throw new Error('MUTATIO618: #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
